export default '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <circle cx="10.8" cy="10.8" r="10.8" fill="url(#paint0_linear_5_42)"/>\
  <path d="M11.6964 13.1676H14.4555L14.9005 10.3194H11.6964V8.80631C11.6964 7.64924 12.0523 6.58118 13.2094 6.58118H14.9895V4.08898C14.7225 4.08898 14.0105 4 12.7644 4C10.1832 4 8.67016 5.33508 8.67016 8.45027V10.3194H6V13.1676H8.67016V20.911C9.20419 21 9.73827 21 10.2723 21C10.8063 21 11.2513 20.911 11.6964 20.911V13.1676Z" fill="white"/>\
  <defs>\
    <linearGradient id="paint0_linear_5_42" x1="4.5" y1="6" x2="17" y2="15.5" gradientUnits="userSpaceOnUse">\
      <stop stop-color="#2AA4F4"/>\
      <stop offset="1" stop-color="#007AD9"/>\
    </linearGradient>\
  </defs>\
</svg>'
